import { COMPETITIONS_CONTEXTS } from "./competitionContexts";

export const hsespace_awards = 'hsespace_awards';

export enum HSESPACE_CONTEXTS {
    'deziiign/s-advertising-and-pr' = 'advertisingandprawards',
    'deziiign/s-biology' = 'biologyawards',
    'deziiign/s-hseissek' = 'hseissekawardshsespace_awards',
    'deziiign/s-oriental' = 'orientalawards',
    'deziiign/s-geography' = 'geographyawards',
    'deziiign/s-hseincomm' = 'hseincommawards',
    'deziiign/s-digital' = 'digitalawards',
    'deziiign/s-public-administration' = 'publicadministrationawards',
    'deziiign/s-urban-development' = 'urbandevelopmentawards',
    'deziiign/s-computer-science-and-engineering' = 'computerscienceandengineeringawards',
    'deziiign/s-history' = 'historyawards',
    'deziiign/s-arthistory' = 'arthistoryawards',
    'deziiign/s-cinema' = 'cinemaawards',
    'deziiign/s-culturology' = 'culturologyawards',
    'deziiign/s-mathematics' = 'mathematicsawards',
    'deziiign/s-media' = 'mediaawards',
    'deziiign/s-international-relations' = 'internationalrelationsawards',
    'deziiign/s-management' = 'managementawards',
    'deziiign/s-music' = 'musicawards',
    'deziiign/s-political-science' = 'politicalscienceawards',
    'deziiign/s-software-engineering' = 'softwareengineeringawards',
    'deziiign/s-production' = 'productionawards',
    'deziiign/s-psychology' = 'psychologyawards',
    'deziiign/s-sociology' = 'sociologyawards',
    'deziiign/s-physics' = 'physicsawards',
    'deziiign/s-philology' = 'philologyawards',
    'deziiign/s-philosophy' = 'philosophyawards',
    'deziiign/s-chemistry' = 'chemistryawards',
    'deziiign/s-economy' = 'economyawards',
    'deziiign/s-extra' = 'extraawards',
    'deziiign/s-jurisprudence' = 'jurisprudenceawards',
    'deziiign/s-mediadepartment' = 'mediadepartment_awards',
    'deziiign/s-hsetto' = 'hsettoawards',
    'deziiign/hsespacecreative' = 'hsecreativeawards',
    'deziiign/hsespacefilm' = 'filmawards',
    'deziiign/hsecreativehub' = 'hsecreativehubawards',
    'deziiign/s-virtualspace' = 'virtualawards',
   
  }

  export const getHsespaceCompetitionContext = (ctxName: string) => {
    const computedCtx = ctxName.toLowerCase()
    if(ctxName === 'deziiign/hsespace'){
      return [
        COMPETITIONS_CONTEXTS.hsespace_awards,
        // COMPETITIONS_CONTEXTS.faculty_hsespace_awards,
        // COMPETITIONS_CONTEXTS.hsespace_partnerbriefs,
      ]
    }
    if(ctxName === 'deziiign/s-virtualspace'){
      return [COMPETITIONS_CONTEXTS.virtualawards, COMPETITIONS_CONTEXTS.hsespace_awards]
    }
    //@ts-ignore
    return [HSESPACE_CONTEXTS[computedCtx], COMPETITIONS_CONTEXTS.hsespace_awards]
  }
import { COMPETITIONS_CONTEXTS } from "./competitionContexts";

export const hsespace_awards = 'hsespace_awards';

export enum HSESPACE_CONTEXTS {
    'deziiign/s-advertising-and-pr' = 'advertisingandprawards',
    'deziiign/s-biology' = 'biologyawards',
    'deziiign/s-hseissek' = 'hseissekawardshsespace_awards',
    'deziiign/s-oriental' = 'orientalawards',
    'deziiign/s-geography' = 'geographyawards',
    'deziiign/s-hseincomm' = 'hseincommawards',
    'deziiign/s-digital' = 'digitalawards',
    'deziiign/s-public-administration' = 'publicadministrationawards',
    'deziiign/s-urban-development' = 'urbandevelopmentawards',
    'deziiign/s-computer-science-and-engineering' = 'computerscienceandengineeringawards',
    'deziiign/s-history' = 'historyawards',
    'deziiign/s-arthistory' = 'arthistoryawards',
    'deziiign/s-cinema' = 'cinemaawards',
    'deziiign/s-culturology' = 'culturologyawards',
    'deziiign/s-mathematics' = 'mathematicsawards',
    'deziiign/s-media' = 'mediaawards',
    'deziiign/s-international-relations' = 'internationalrelationsawards',
    'deziiign/s-management' = 'managementawards',
    'deziiign/s-music' = 'musicawards',
    'deziiign/s-political-science' = 'politicalscienceawards',
    'deziiign/s-software-engineering' = 'softwareengineeringawards',
    'deziiign/s-production' = 'productionawards',
    'deziiign/s-psychology' = 'psychologyawards',
    'deziiign/s-sociology' = 'sociologyawards',
    'deziiign/s-physics' = 'physicsawards',
    'deziiign/s-philology' = 'philologyawards',
    'deziiign/s-philosophy' = 'philosophyawards',
    'deziiign/s-chemistry' = 'chemistryawards',
    'deziiign/s-economy' = 'economyawards',
    'deziiign/s-extra' = 'extraawards',
    'deziiign/s-jurisprudence' = 'jurisprudenceawards',
    'deziiign/s-mediadepartment' = 'mediadepartment_awards',
    'deziiign/s-hsetto' = 'hsettoawards',
    'deziiign/hsespacecreative' = 'hsecreativeawards',
    'deziiign/hsespacefilm' = 'filmawards',
    'deziiign/hsecreativehub' = 'hsecreativehubawards',
    'deziiign/s-virtualspace' = 'virtualawards',
   
  }

  export const getHsespaceCompetitionContext = (ctxName: string) => {
    const computedCtx = ctxName.toLowerCase()
    if(ctxName === 'deziiign/hsespace'){
      return [
        COMPETITIONS_CONTEXTS.hsespace_awards,
        // COMPETITIONS_CONTEXTS.faculty_hsespace_awards,
        // COMPETITIONS_CONTEXTS.hsespace_partnerbriefs,
      ]
    }
    if(ctxName === 'deziiign/s-virtualspace'){
      return [COMPETITIONS_CONTEXTS.virtualawards, COMPETITIONS_CONTEXTS.hsespace_awards]
    }
    //@ts-ignore
    return [HSESPACE_CONTEXTS[computedCtx], COMPETITIONS_CONTEXTS.hsespace_awards]
  }
